import isTestCafeEnabled from '@/helpers/isTestCafeEnabled'

const apiPrefix = isTestCafeEnabled()
  ? import.meta.env.VITE_APP_API_BASE_TESTCAFE_URL
  : import.meta.env.VITE_APP_API_URL

export default {
  apiPrefix: `${apiPrefix}v1/`,
  endpoints: {
    filter: 'public/child-choice-path/filter',
    resourceFilter: 'public/resource/filters',
    child: 'public/child-choice-path/child-edition/:childId',
    childRetention: 'public/child-choice-path/retention/child-edition/:childId',
    childHashRetention: 'public/child-choice-path/retention-hash/:childEditionRetentionHash',
    payment: 'public/child-choice-path/payment',
    counters: 'public/child-choice-path/counters',
    paymentStatus: 'public/payment-status/p24-session-id/:sessionId',
    installmentsPayment: 'public/child-choice-path/payment/hash/:hash'
  },
  get(endpointLabel, params) {
    if (this.endpoints[endpointLabel] === undefined) {
      throw new Error('undefined api path')
    }

    let url = this.endpoints[endpointLabel]

    if (typeof params === 'object') {
      Object.keys(params).forEach((param) => {
        url = url.replace(`:${param}`, params[param])
      })
    } else if (url.indexOf('/:') > 0) {
      url = url.substring(0, url.indexOf('/:'))
    }

    return this.apiPrefix.concat(url)
  }
}
